import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfServiceFR() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 to-indigo-100">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center text-indigo-600 hover:text-indigo-700 mb-6 transition-colors duration-200"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          Retour à l'application
        </button>

        <article className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Conditions d'Utilisation</h1>

          <div className="space-y-6 text-gray-700">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Informations sur l'Entreprise</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Simple Stickers est exploité par <span className="font-semibold">Puretech s.r.o.</span>,
                  une <span className="font-semibold">société à responsabilité limitée</span> constituée en vertu des lois de la <span className="font-semibold">République tchèque</span>.
                </p>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-700 mb-2">Détails de l'Entreprise :</p>
                  <ul className="text-sm text-gray-600 space-y-1">
                    <li><strong>Numéro d'Identification (IČO) :</strong> 05503795</li>
                    <li><strong>Statut TVA :</strong> Non assujetti</li>
                    <li><strong>Adresse du Bureau :</strong> Heydukova 1035, 54401 Dvůr Králové nad Labem, République tchèque</li>
                    <li><strong>E-mail :</strong> support@simplestickers.app</li>
                    <li><strong>Site Web :</strong> <a href="https://www.simplestickers.app" target="_blank" rel="noopener noreferrer" className="text-indigo-600 hover:text-indigo-800 hover:underline">www.simplestickers.app</a></li>
                    <li><strong>Représentée par :</strong> Pavel Vlček</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Acceptation des Conditions</h2>
              <p className="leading-relaxed">
                En accédant et en utilisant Simple Stickers ("le Service"), vous acceptez et acceptez d'être lié par les termes et dispositions de cet accord. Si vous n'êtes pas d'accord avec ce qui précède, veuillez ne pas utiliser ce service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Description du Service</h2>
              <p className="leading-relaxed">
                Simple Stickers est une application de gestion de tâches et de projets qui fournit aux utilisateurs des outils pour organiser des notes adhésives en utilisant un système de tableau de type Kanban. Le service comprend des niveaux gratuits et premium avec différents ensembles de fonctionnalités et limites d'utilisation.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Comptes Utilisateurs</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Vous êtes responsable du maintien de la confidentialité de votre compte et de votre mot de passe et de la restriction de l'accès à votre ordinateur. Vous acceptez d'assumer la responsabilité de toutes les activités qui se produisent sous votre compte ou mot de passe.
                </p>
                <p className="leading-relaxed">
                  Vous devez fournir des informations précises et complètes lors de la création de votre compte et maintenir ces informations à jour.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Abonnement et Conditions de Paiement</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Niveau Gratuit :</strong> Comprend l'accès aux fonctionnalités de base avec des limitations sur le nombre de notes adhésives (50) et de suggestions d'IA (10 par jour).
                </p>
                <p className="leading-relaxed">
                  <strong>Niveau Premium :</strong> Disponible pour 48 $ par an, comprend des limites accrues (1000 notes adhésives, 100 suggestions d'IA par jour) et des fonctionnalités supplémentaires telles que les capacités de partage de notes adhésives.
                </p>
                <p className="leading-relaxed">
                  Le traitement des paiements est géré par Polar. Les abonnements se renouvellent automatiquement sauf s'ils sont annulés. Vous pouvez annuler votre abonnement à tout moment via les paramètres de votre compte.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Utilisation Acceptable</h2>
              <p className="leading-relaxed">
                Vous acceptez de ne pas utiliser le service pour stocker, transmettre ou distribuer du contenu illégal, nuisible, menaçant, abusif, harcelant, diffamatoire, vulgaire, obscène ou autrement répréhensible. Vous acceptez également de ne pas interférer avec le service ou tenter d'accéder à des comptes appartenant à d'autres.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Confidentialité et Protection des Données Personnelles</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Votre vie privée est importante pour nous. Pour plus de détails sur la façon dont nous collectons, utilisons et protégeons vos informations personnelles, veuillez consulter notre <a href="/privacy-policy" className="text-indigo-600 hover:text-indigo-800 hover:underline font-medium">Politique de Confidentialité</a>.
                </p>
                <p className="leading-relaxed">
                  En utilisant ce service, vous acceptez également notre Politique de Confidentialité et le traitement de vos données personnelles conformément au RGPD et aux lois applicables sur la protection des données.
                </p>
                <p className="leading-relaxed">
                  Pour exercer vos droits en vertu du RGPD ou pour des demandes concernant la protection des données, veuillez nous contacter à <strong>support@simplestickers.app</strong>.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Disponibilité du Service et Support</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Disponibilité du Service :</strong> Nous nous efforçons d'assurer une disponibilité maximale du service et un fonctionnement fiable. En cas de pannes imprévues, nous travaillons à les résoudre rapidement. Le service est fourni "tel quel" sans garanties formelles de disponibilité.
                </p>
                <p className="leading-relaxed">
                  <strong>Maintenance :</strong> Pour garantir la sécurité et la stabilité, nous pouvons effectuer une maintenance continue du service. Nous essayons de planifier la maintenance prévue pendant les périodes de faible utilisation et de fournir un préavis dans la mesure du possible. Dans les cas urgents (par exemple, correctifs de sécurité), la maintenance peut avoir lieu sans préavis.
                </p>
                <p className="leading-relaxed">
                  <strong>Support :</strong> Nous offrons un support technique par e-mail à support@simplestickers.app. Nous nous efforçons de répondre aussi rapidement que possible, cependant des délais de réponse spécifiques ne sont pas garantis.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Politique de Remboursement</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Garantie de Remboursement de 30 Jours :</strong> Si vous n'êtes pas satisfait du service premium, vous pouvez demander un remboursement complet dans les 30 jours suivant votre achat initial. Après 30 jours, tous les paiements sont définitifs et non remboursables.
                </p>
                <p className="leading-relaxed">
                  <strong>Erreurs de Facturation :</strong> Si vous pensez avoir été facturé de manière incorrecte, contactez-nous à support@simplestickers.app dans les 30 jours suivant la facturation.
                </p>
                <p className="leading-relaxed">
                  <strong>Traitement des Remboursements :</strong> Les remboursements approuvés seront traités dans un délai de 10 à 14 jours ouvrables vers le mode de paiement d'origine. Nous nous réservons le droit d'approuver ou de refuser les demandes de remboursement à notre seule discrétion.
                </p>
                <p className="text-sm text-gray-600">
                  Remarque : Les annulations d'abonnement n'entraînent pas automatiquement de remboursements. Vous devez explicitement demander un remboursement dans le délai de 30 jours.
                </p>
              </div>
            </section>
            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Restrictions d'Âge et Éligibilité</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  <strong>Âge Minimum :</strong> Vous devez avoir au moins 16 ans pour utiliser ce service.
                </p>
                <p className="leading-relaxed">
                  <strong>Consentement Parental :</strong> Les utilisateurs de moins de 18 ans doivent avoir le consentement parental ou tutélaire pour utiliser le service.
                </p>
                <p className="leading-relaxed">
                  <strong>Utilisateurs Professionnels :</strong> Les comptes professionnels exigent que l'utilisateur ait l'autorité d'engager l'organisation.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Droit Applicable et Juridiction</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Ces Conditions seront régies et interprétées conformément aux lois de la République tchèque, sans égard à ses dispositions relatives aux conflits de lois.
                </p>
                <p className="leading-relaxed">
                  Tout litige découlant de ces Conditions ou de votre utilisation du Service sera soumis à la juridiction exclusive des tribunaux de la République tchèque.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Modération du Contenu</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Nous nous réservons le droit de supprimer, modifier ou refuser d'afficher tout contenu qui viole ces Conditions ou que nous jugeons inapproprié, à notre seule discrétion.
                </p>
                <p className="leading-relaxed">
                  Si vous pensez qu'un contenu doit être examiné, contactez-nous à support@simplestickers.app.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Propriété Intellectuelle</h2>
              <p className="leading-relaxed">
                Le service et son contenu original, ses fonctionnalités et sa fonctionnalité sont la propriété de Simple Stickers et sont protégés par les lois internationales sur le droit d'auteur, les marques de commerce, les brevets, les secrets commerciaux et autres lois sur la propriété intellectuelle.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Limitation de Responsabilité</h2>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  Dans toute la mesure permise par la loi applicable, Simple Stickers ne sera pas responsable des dommages indirects, accessoires, spéciaux, consécutifs ou punitifs, y compris, sans s'y limiter, la perte de profits, de données, d'utilisation, de clientèle ou d'autres pertes intangibles, résultant de votre utilisation du service.
                </p>
                <p className="leading-relaxed">
                  Cette limitation de responsabilité ne s'applique pas aux dommages causés par une faute intentionnelle ou une négligence grave, ou comme autrement interdit par la loi applicable.
                </p>
                <p className="leading-relaxed">
                  Notre responsabilité totale envers vous pour toute réclamation découlant de votre utilisation du service ne dépassera pas le montant que vous nous avez payé au cours des 12 mois précédant la réclamation, ou 100 €, selon le montant le plus élevé.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Résiliation</h2>
              <p className="leading-relaxed">
                Nous pouvons résilier ou suspendre votre compte et bloquer l'accès au service immédiatement, sans préavis ni responsabilité, à notre seule discrétion, pour quelque raison que ce soit, y compris, sans s'y limiter, si vous violez les Conditions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Modifications des Conditions</h2>
              <p className="leading-relaxed">
                Nous nous réservons le droit de modifier ou de remplacer ces Conditions à tout moment. Si une révision est substantielle, nous fournirons un préavis d'au moins 30 jours avant l'entrée en vigueur des nouvelles conditions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Informations de Contact</h2>
              <div className="space-y-4">
                <p className="leading-relaxed">
                  Si vous avez des questions concernant ces Conditions d'Utilisation, veuillez nous contacter :
                </p>

                <div className="bg-gray-50 p-4 rounded-lg">
                  <p className="text-sm text-gray-700">
                    <strong>E-mail :</strong> support@simplestickers.app
                  </p>
                  <p className="text-xs text-gray-500 mt-2">
                    Pour toutes les demandes concernant le support, les questions juridiques, la confidentialité, la protection des données et les questions commerciales
                  </p>
                </div>
              </div>
            </section>
          </div>
        </article>
      </div>
    </div>
  );
}
